module.exports = __webpack_public_path__ + "static/media/Jan_2026_1.a57ded5b.webp";